import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";
import { route } from "preact-router";
import { ValidateCode } from "../Common/helpers";
export default function AmbassadorJoinDealDialog(props) {
	console.log("AmbassadorJoinDealDialog")
	const [form, setForm] = useState({ descr: "" });
	const [disabled, setDisabled] = useState(false);
	const handleClose = () => {
		onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		setDisabled(ValidateCode(form.code));
	}, [form]);
	const handleSubmitNewDeal = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				descr: form.code,
			}),
		};
		fetch("/api/4e995fe90a4c4d03bf75bed4f4f5a695", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//console.log("route to newealv");
						route("/newdealv/" + res.id + "/0");
						//window.location.replace("/newdealv/" + res.id+"/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Rejoindre un dossier de vente
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez démarrer un dossier de vente
				</Typography>
				<Typography variant="h5" gutterBottom>
					Vous avez reçu par email un code à 10 caractères (ex: 26-4b80-9e11) de la part du vendeur principal
				</Typography>
				<Typography variant="h6" gutterBottom>
					Veuillez saisir ce code ci-dessous
				</Typography>
				<div style="padding-right: 100px; padding-left: 100px;">
					<TextField
						id="code"
						name="code"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder="Code recu par email XX-XXXX-XXXX"
						fullWidth
						margin="dense"
						size="small"
						value={form.code}
						onChange={handleChange}
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="flex-end" alignItems="center">
					<Box>
						<Button variant="outlined" onClick={handleSubmitNewDeal} style="margin: 10px;" disabled={!disabled}>
							Rejoindre
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
